/**
 * Product Page Performance Fixes
 * This file contains patches to improve PDP performance and prevent crashes
 * Waits for DOMContentLoaded to avoid interfering with revenueHunt and other apps
 */

(function() {
  'use strict';

  // Main initialization function
  function initProductFixes() {
    // Fix 1: Optimize Recently Viewed Products AJAX requests
    if (typeof window.optimizeRecentlyViewedProducts === 'undefined') {
      window.optimizeRecentlyViewedProducts = function(productHandles) {
        if (!productHandles || productHandles.length === 0) return;

        var requestQueue = [];
        var completedCount = 0;
        var maxConcurrent = 3; // Limit concurrent requests
        var activeRequests = 0;
        var results = [];

        // Create request queue (skip current product)
        for (var i = productHandles.length - 2; i >= 0; i--) {
          requestQueue.push(productHandles[i]);
        }

        function processNextRequest() {
          if (requestQueue.length === 0 || activeRequests >= maxConcurrent) {
            return;
          }

          var handle = requestQueue.shift();
          activeRequests++;

          jQuery.ajax({
            url: '/products/' + handle + '?view=card',
            cache: false,
            dataType: 'html',
            timeout: 5000, // Add 5 second timeout
            success: function(response) {
              try {
                var $item = $(response).find('.grid__item');
                if ($item.length && $item.data('handle')) {
                  var productHandle = $item.data('handle');
                  var index = productHandles.indexOf(productHandle);
                  if (index > -1) {
                    results.push({
                      index: index,
                      html: $item.get(0).outerHTML
                    });
                  }
                }
              } catch (err) {
                console.error('Error processing product card:', err);
              }
            },
            error: function(xhr, status, error) {
              console.warn('Failed to load product:', handle, status);
            },
            complete: function() {
              activeRequests--;
              completedCount++;

              // Process next request
              processNextRequest();

              // Check if all requests completed
              if (completedCount >= requestQueue.length + activeRequests) {
                renderRecentlyViewed(results);
              }
            }
          });

          // Try to process more requests
          if (activeRequests < maxConcurrent) {
            processNextRequest();
          }
        }

        function renderRecentlyViewed(products) {
          try {
            // Sort by original index
            products.sort(function(a, b) { return b.index - a.index; });

            // Append to container
            var $container = $('.product-recently-viewed-tab');
            products.forEach(function(item) {
              if ($(item.html).find('.grid-product__wrapper').length) {
                $container.append(item.html);
              }
            });

            // Initialize carousel if function exists
            if (typeof window.initRecentlyViewedSlick === 'function') {
              window.initRecentlyViewedSlick();
            }

            // Remove loading class - ONLY if it's not part of revenueHunt or quiz elements
            setTimeout(function() {
              // Safety check: don't remove class from quiz or revenueHunt elements
              var classesToPreserve = [
                'revenuehunt',
                'revenue-hunt', 
                'quiz',
                'product-quiz',
                'recommendation-quiz',
                'shopquizkit'
              ];
              
              var hasProtectedClass = classesToPreserve.some(function(protectedClass) {
                return $container.hasClass(protectedClass) || 
                       $container.find('[class*="' + protectedClass + '"]').length > 0;
              });
              
              // Only remove 'show-onload' if container doesn't have protected classes
              if (!hasProtectedClass) {
                $container.removeClass('show-onload');
              }
            }, 1500);
          } catch (err) {
            console.error('Error rendering recently viewed:', err);
          }
        }

        // Start processing with limited concurrency
        for (var j = 0; j < Math.min(maxConcurrent, requestQueue.length); j++) {
          processNextRequest();
        }
      };
    }
  }

  // Wait for DOMContentLoaded before initializing product fixes
  // This ensures revenueHunt and other third-party apps load first
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      // Add additional delay to ensure all third-party scripts are loaded
      setTimeout(initProductFixes, 500);
    });
  } else {
    // DOM already loaded, but still add a small delay
    setTimeout(initProductFixes, 500);
  }

})();
